import { PhoneFrame } from "@/components/marketing";
import { channelPreview } from "../../../../data";

const { shop, notification } = channelPreview;

interface NoticeProps {
  app: string;
  when: string;
  title: string;
  body: string;
}

const Notice = ({ app, when, title, body }: NoticeProps) => (
  <div className="grid gap-1 rounded-2xl bg-white/85 p-3 text-ink shadow-card backdrop-blur">
    <div className="flex items-center gap-2 text-[10.5px] text-ink-muted">
      <span className="grid size-5 place-items-center rounded-md bg-primary text-[10px] font-extrabold text-white">
        {shop.initial}
      </span>
      <span className="font-semibold tracking-[0.04em]">{app}</span>
      <span className="ml-auto">{when}</span>
    </div>
    <b className="text-[12.5px] leading-snug">{title}</b>
    <span className="text-[12px] leading-snug">{body}</span>
  </div>
);

// The campaign as a lock-screen notification from the Fydo app, under the
// big clock, with an older wallet reminder below it.
const NotificationPreview = () => (
  <PhoneFrame contentClassName="grid content-start gap-3 bg-gradient-to-b from-tone-lilac to-tone-sky px-3 pt-4 pb-9">
    <div className="grid justify-items-center gap-0.5 pb-3 text-ink">
      <small className="text-[12px] font-semibold">{notification.date}</small>
      <b className="text-[3.2rem] leading-none font-light tracking-tight">
        {notification.time}
      </b>
    </div>
    <Notice
      app={notification.app}
      when={notification.when}
      title={notification.title}
      body={notification.body}
    />
    <Notice {...notification.second} />
  </PhoneFrame>
);

export default NotificationPreview;
